export const useCoverageCarousel = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1250 },
      items: 3,
    },
    desktop1: {
      breakpoint: { max: 1250, min: 1024 },
      items: 2,
    },
    desktop2: {
      breakpoint: { max: 1024, min: 900 },
      items: 2,
    },
    desktop3: {
      breakpoint: { max: 900, min: 800 },
      items: 2,
    },
    desktop4: {
      breakpoint: { max: 800, min: 576 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
    },
  };

  return {
    responsive,
  };
};
